/**
 * Removes file extension from an indication ID to create a safe key for Rolodex.
 * This avoids dots in keys that would conflict with delete_data path notation.
 * Only removes extension if present (e.g., ".nde"), leaves UUID-style IDs unchanged.
 *
 * Examples:
 * - "AP_mtzion_nb_00008_LS1_S01.nde" → "AP_mtzion_nb_00008_LS1_S01"
 * - "abc-123-def-456" (UUID, no extension) → "abc-123-def-456" (unchanged)
 */
export const getIndicationKey = (indicationId: string): string => {
  return indicationId.replace(/\.[^.]+$/, '')
}
